import { Outlet, ScrollRestoration } from 'react-router-dom'
import useCommonEventBus from 'src/hooks/useEventBus/useCommonEventBus'
import { PageLayoutWrap } from 'src/layout/Layout'
import Modal from 'src/components/atomic/Molecules/Modal'
import useSocketPingPongHook from 'src/hooks/useSocketPingPong.hook'
import usePageLayoutBeforeUnloadHook from 'src/hooks/usePageLayoutBeforeUnload.hook'
import SessionStorageUtils from 'src/utils/SessionStorage.utils'
import { useEffect } from 'react'
import { setModalItems } from 'src/store/Reducer/common/modalSlice'
import { useAppDispatch } from 'src/hooks/redux/useAppDispatch'
import useMatchHook from 'src/hooks/useMatch.hook'
import useMediaQueryHook from 'src/hooks/useMediaQuery.hook'
import BackgroundToForegroundDimScreen from 'src/components/atomic/Molecules/BackgroundToForegroundDimScreen'

const PageLayout = () => {
  const { currentMedia } = useMediaQueryHook()
  const dispatch = useAppDispatch()
  const { m_login } = useMatchHook()
  const { getStorageData, deleteStorageData } = SessionStorageUtils()
  const getErrorMsg = getStorageData('errorModalMsg')

  useCommonEventBus()
  // useDocumentTitleHook()
  useSocketPingPongHook()
  usePageLayoutBeforeUnloadHook()

  useEffect(() => {
    const setOneVh = () => {
      const vh = window.innerHeight * 0.01
      document.documentElement.style.setProperty('--vh', `${vh}px`)
    }
    setOneVh()
    window.addEventListener('resize', setOneVh)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.pathname])

  // usage: '/' route 로 이동 후 모달 노출
  useEffect(() => {
    if (getErrorMsg && m_login) {
      dispatch(
        setModalItems({
          type: 'alert',
          text: getErrorMsg,
        }),
      )
      deleteStorageData('errorModalMsg')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getErrorMsg, m_login])

  //Outlet Component : AccountPage, ServicePage
  return (
    <PageLayoutWrap media={currentMedia} id={'pagelayout'}>
      <ScrollRestoration />
      <Outlet />
      <Modal />
      <BackgroundToForegroundDimScreen />
    </PageLayoutWrap>
  )
}
export default PageLayout
